import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap, tap } from 'rxjs';
import { version } from '../../../../package.json';
import {
  GetLanguage,
  GetLanguageFailed,
  GetLanguageSuccess,
  ValidateSubscription,
  ValidateSubscriptionFailed,
  ValidateSubscriptionSuccess,
} from '../actions/eliqua.actions';
import { GetLiterals, GetSelectedLanguage } from '../actions/literals.actions';
import { EliquaService } from '../services/eliqua.service';

@Injectable()
export class EliquaEffects {
  constructor(
    private actions$: Actions,
    private eliquaService: EliquaService,
  ) {}

  validateSubscription$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ValidateSubscription),
      switchMap(() =>
        this.eliquaService.getSubscriptionValidity().pipe(
          switchMap((res) => of(ValidateSubscriptionSuccess({ res }))),
          catchError((error) => of(ValidateSubscriptionFailed(error))),
        ),
      ),
    ),
  );

  checkBackendVersion$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ValidateSubscriptionSuccess),
        switchMap(() =>
          this.eliquaService.getCoreVersion().pipe(
            tap((res) => {
              const backendVersion: string = res?.payload?.data?.version ?? '';
              const frontendVersion = version;

              let backendApiTag: string;
              let frontendApiTag: string;

              try {
                backendApiTag = backendVersion.split('-')[0].split('+')[1] ?? '';
                frontendApiTag = frontendVersion.split('+')[1] ?? '';
              } catch {
                backendApiTag = '';
                frontendApiTag = '';
              }

              if (backendApiTag && frontendApiTag && backendApiTag === frontendApiTag) {
                console.log(
                  `%cVERSION MATCH: PASS\nBackend: ${backendVersion}\nDragonfly: ${frontendVersion}`,
                  'color: #27ae60; font-weight: bold',
                );
              } else {
                console.warn('VERSION MATCH: FAIL', '\nBackend: ', backendVersion, '\nDragonfly: ', frontendVersion);
              }
            }),
            catchError(() => of(null)),
          ),
        ),
      ),
    { dispatch: false },
  );

  getLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetLanguage),
      switchMap(() =>
        this.eliquaService.getLanguage().pipe(
          switchMap((res) => of(GetLanguageSuccess({ res }), GetLiterals(), GetSelectedLanguage())),
          catchError((error) => of(GetLanguageFailed(error))),
        ),
      ),
    ),
  );
}
